import script from "./DocumentReviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentReviewView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentReviewView.vue?vue&type=style&index=0&id=0ec8b31d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ec8b31d"]])

export default __exports__